export const requestTrackingPermissionsAsync = () =>
  new Promise((resolve) => resolve({ status: null }));
